<template>
  <v-container class="px-0" fluid>
    <v-row class="mx-0 panel">
      <div ref="panelTabs" class="panel-tabs align-end">
        <div class="panel-tabs__wrapper">
          <v-btn
            v-for="(item, index) in accounts"
            v-bind:key="item.account_id"
            v-bind:index="index"
            class="panel-tabs__item"
            :class="{ 'panel-tabs__item--active': activeTabModel === index }"
            @click="$store.commit('account/setActive', index)"
          >
            <v-divider v-if="activeTabModel !== index && index !== 0" class="panel-tabs__item--divider" vertical />
            <span>{{ item.account.login }}</span>
            <v-btn x-small class="btn-close mr-1" icon v-on:click="closeAccount(item)">
              <v-icon small>close</v-icon>
            </v-btn>
          </v-btn>
        </div>
        <advanced-search @search="onAdvancedSearch" />
      </div>
      <div class="search-box">
        <v-toolbar-items
          height="35"
        >

          <v-row
            align="center"
            class="mx-0"
          >
            <v-combobox
              class="pt-0 pb-0 mt-3 mb-0 mr-2 ml-4 search-input purple-input"
              :items="$store.state.auth.recentViews"
              :loading="searching"
              color="purple"
              label="Search..."
              md-layout="box"
              autocomplete="off"
              v-model="search"
              append-outer-icon="search"
              @click:append-outer="searchAccount"
              v-on:keyup.enter="searchAccount"
              search-input=""
              :menu-props='{ "closeOnClick": true }'
              @input="setSearch"
              @input.native="setSearch"
            />

          </v-row>
        </v-toolbar-items>
      </div>

    </v-row>

    <user-main-view
      v-if="activeAccount"
      ref="account-tab-item"
      transition="slide-x-transition"
    ></user-main-view>


    <v-dialog
      v-model="searchResultDialog"
      width="850"
    >
      <v-card
        :loading="searching"
      >
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Accounts Found
        </v-card-title>

        <v-card-text class="px-0 pb-0">

          <v-data-table
            :headers="searchResultHeaders"
            :items="searchResultAccounts"
            :loading="searchResultDialogLoading"
            :items-per-page="searchResultPagination.perpage"
            :hide-default-footer="!showResultPagination"
            :server-items-length="searchResultPagination.total"
            :options.sync="options"
            :footer-props="{
              'items-per-page-options': [15, 30, 45]
            }"
            fixed-header
            :height="searchResultAccounts.length > 7 ? 400 : 'auto'"
          >

            <template v-slot:item.action="{ item }">
              <v-btn
                color="info"
                @click="openAccount(item)"
                small
                style="white-space: nowrap"
                :loading="searchResultDialogLoading"
                :disabled="searchResultDialogLoading"
              >
                Open
                <v-icon small right dark>mdi-account-box-multiple</v-icon>
              </v-btn>
            </template>

            <template v-slot:item.frozen="{ value }">
              {{ getStatusLabel(value) }}
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="searchResultDialogLoading"
            :disabled="searchResultDialogLoading"
            color="warrning"
            text
            @click="searchResultDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <manual-transaction text="" size="icon" />

  </v-container>
</template>

<style lang="scss">
  .panel {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    background-color: #FFFFFF;

    @media (max-width: 1024px) {
      flex-wrap: wrap;
    }
  }

  .panel-tabs {
    display: flex;
    flex-grow: 0;
    gap: 6px;
    width: 85%;

    @media (max-width: 1024px) {
      order: 2;
      padding-right: 37px;
      width: 100%;
    }

    &__wrapper {
      max-width: 95%;
      padding-left: 4px;
      display: flex;
      gap: 6px;
    }


    &__item {
      flex-grow: 1;
      flex-shrink: 1;
      width: 200px;
      text-align: left;
      padding: 0 0 0 8px !important;
      min-width: 35px !important;

      box-shadow: none;
      border-radius: 12px 12px 0 0;
      background-color: #FFFFFF !important;

      &:hover &--divider {
        display: none;
      }

      &--active {
        background-color: #eeeeee !important;
      }

      &--divider {
        position: absolute;
        left: -10px;
        border-width: 0 2px 0px 0 !important;
      }

      & > span {
        display: flex;
        justify-content: left;
        width: 100%;

        > span {
          max-width: 80%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .btn-close {
    position: absolute;
    right: 0;
  }

  .account-tabs-panel > [role="tablist"] {
    padding-right: 300px;
  }

  .search-input {
    height: 35px !important;
  }

  .search-box {
    @media (max-width: 1024px) {
      order: 1;
      width: 97%;
    }
  }
</style>

<script>
  import { isArray, uniq } from 'lodash'
  import { API } from '@/utils/api'
  import { mapGetters } from 'vuex'
  import ManualTransaction from '@/components/helper/ManualTransaction'
  import AdvancedSearch from '@/components/helper/AdvancedSearch'
  import UserMainView from '@/components/user/MainView'

  export default {
    data: () => ({
      searchResultDialog: false,
      searchResultDialogLoading: false,
      search: '',
      searching: false,
      tabs: null,
      // accounts: [],
      responsive: false,
      // accountsTabModel: null,
      searchResultHeaders: [
        { text: 'Account ID', value: 'account_id', sortable: false },
        { text: 'Login', value: 'login', sortable: false },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Created', value: 'created', sortable: false },
        { text: 'Balance', value: 'balance', sortable: false },
        { text: 'Bonus', value: 'bonus', sortable: false },
        { text: 'Status', value: 'frozen', sortable: false },
        { text: '#', value: 'action', sortable: false },
      ],
      searchResultAccounts: [],
      searchResultPagination: {},
      recent_views: [],
      options: {},
      advancedSearchParams: {},
      statusList: [
        { text: 'Open', value: 0 },
        { text: 'Closed', value: 1 },
        { text: 'Frozen', value: 2 },
        { text: 'Temporary Frozen', value: 3 },
        { text: 'Self Exclusion Permanent', value: 4 },
        { text: 'Frozen by Refund', value: 5 },
        { text: 'Frozen by Security Answer', value: 6 },
        { text: 'Not Verified', value: 7 },
        { text: 'Closed by Regulator', value: 8 },
        { text: 'Closed by License', value: 9 },
        { text: 'Gambling Addiction', value: 10 },
        { text: 'Frozen by Suspicion', value: 11 },
        { text: 'Closed by Antifraud', value: 12 },
        { text: 'Closed by Chargeback', value: 13 },
      ],
    }),

    computed: {
      ...mapGetters({ activeTabModel: 'account/activeTabModel', activeAccount: 'account/active', accounts: 'account/list' }),

      showResultPagination() {
        return this.searchResultPagination.perpage && this.searchResultPagination.total && this.searchResultPagination.total > this.searchResultPagination.perpage
      },
    },

    watch: {
      searchResultDialog(newValue) {
        if (!newValue) {
          this.searchResultPagination = {}
          this.searchResultAccounts = []
          this.advancedSearchParams = {}
          this.options = {}
        }
      },

      options(options) {
        if (this.searchResultDialog) {
          this.searchAccount(null, {...this.advancedSearchParams, ...this.tableOptionsToSearchParams(this.options) }, this.advancedSearchParams.entity_id)
        }
      },
    },

    components: {
      AdvancedSearch,
      ManualTransaction,
      UserMainView
    },


    created () {
      if (this.$store.state.auth.recentViews.length == 0) {
        this.$store.dispatch('auth/recentViewLoad', {}).then(() => {
        })
      }

      if (this.$route.params.logins) {
        if (!isArray(this.$route.params.logins)) {
          this.$route.params.logins = uniq(this.$route.params.logins.split(',')).slice(0, 5)
        }

        for (let login of this.$route.params.logins) {
          this.searchReq({ value: login }, login)
        }
      }
    },
    methods: {
      tableOptionsToSearchParams(tableOptions) {
        return {
          perpage: tableOptions.itemsPerPage,
          page: tableOptions.page,
        }
      },

      onAdvancedSearch(params) {
        this.advancedSearchParams = params
        this.searchAccount(null, { ...this.advancedSearchParams, ...this.tableOptionsToSearchParams(this.options) }, this.advancedSearchParams.entity_id)
      },

      searchAccount (event, advancedSearch, entity_id) {
        if ((!this.search || this.search.length <= 3) && !advancedSearch) {
          this.$showError('Short login')
          return
        }

        if (advancedSearch) {
          this.search = ''
        }

        this.searching = true
        this.searchReq({ value: this.search, ...advancedSearch }, this.search, entity_id)
      },

      searchReq (params, login, entity_id) {
        return API.call('/$v/account/search.json', params, { login }, entity_id).then(resp => {
          if (resp.data.length == 1) {
            this.openAccount(resp.data[0])
          } else {
            this.searchResultDialog = true
            this.searchResultAccounts = resp.data
            this.searchResultPagination = resp.pagination
            this.advancedSearchParams = {
              ...params,
              entity_id,
            }
          }
          this.search = ''
        }).then(() => {
          return this.$store.dispatch('auth/recentViewLoad', {})
        }).catch(e => {
        }).finally((r) => {
          this.searching = false
        })
      },

      setSearch (e) {
        if (!e) {
          this.search = ''
        } else if (typeof e === 'string') {
          this.search = e
        } else if (typeof e === 'object') {
          this.search = e.srcElement.value
        }
      },

      openAccount (account) {
        if (!this.accounts.find((p) => p.account_id == account.account_id || p.login == account.login)) {
          this.searching = true
          this.searchResultDialogLoading = true

          this.$store.dispatch('account/load', { value: account.login, account_id: account.account_id, login: account.login }).then(resp => {
            return this.$store.dispatch('account/add', resp.data)
          }).then(() => {
            return this.$store.dispatch('auth/recentViewLoad', {})
          }).catch(e => {
          }).finally(() => {
            this.searchResultDialogLoading = false
            this.searchResultDialog = false
            this.searching = false
          })
        }

      },

      closeAccount (account) {
        this.$store.commit('account/remove', account)
        // this.accounts = this.accounts.filter((p) => p.account_id != account_id)
      },

      onResponsiveInverted () {
        if (window.innerWidth < 991) {
          this.responsive = true
        } else {
          this.responsive = false
        }
      },

      getStatusLabel(status) {
        const label = this.statusList.find(entry => entry.value === status)

        return label?.text ?? 'Closed'
      },
    },

    mounted () {
      this.onResponsiveInverted()
      window.addEventListener('resize', this.onResponsiveInverted)
    },

    beforeDestroy () {
      window.removeEventListener('resize', this.onResponsiveInverted)
    },
  }
</script>
